import Axios from 'axios'

export default {
    state: {
        orders: [],
        balance: 0
    },
    getters: {
        orders(state) {
            return state.orders;
        },
        balance(state) {
            return state.balance
        }
    },
    actions: {
        async getOrders({ commit, getters }) {
            await Axios.get(`${process.env.VUE_APP_API_URL_ORDER}user/${getters.user._id}?type=${getters.user.type}`,
                {
                    headers: {
                        Authorization: "Bearer " + localStorage.getItem("token"),
                    },
                })
                .then(res => {
                    if (res.data.success)
                        commit('setOrders', res.data.data)
                })
        },
        async getBalance({ commit, getters }) {
            await Axios.get(`${process.env.VUE_APP_API_URL_ORDER}balance/${getters.user._id}`,
                {
                    headers: {
                        Authorization: "Bearer " + localStorage.getItem("token"),
                    },
                })
                .then(res => {
                    if (res.data.success)
                        commit('setBalance', res.data.data)
                })
        },
        async checkIn({ commit }, payload) {
            commit('setLoading')
            commit('clearError')
            return await Axios.get(`https://test.clictopay.com/payment/rest/register.do?password=94DBy6sCj&userName=100090510&returnUrl=${payload.returnUrl}&orderNumber=${payload.orderNumber}&currency=${payload.currency}&amount=${payload.amount}`, payload)
                .then(res => {
                    // if (res.data.success) {
                    console.log(res.data)
                    if (res.data.formUrl) {
                        commit('setLoading');
                        localStorage.setItem('packID', payload.orderNumber)
                        return res.data.formUrl
                    }
                    else
                        throw new Error(res.data.errorMessage);
                }).catch(error => {//catch error
                    console.log(error)
                    commit('setLoading');
                    commit('clearError');
                    commit('setError', error);
                });
        },
        async createOrder({ commit }, payload) {
            commit('setLoading')
            commit('clearError')
            return await Axios.post(process.env.VUE_APP_API_URL_ORDER, payload,
                {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': 'Bearer ' + localStorage.getItem('token')
                    }
                })
                .then(res => {
                    console.log('res', res.data)
                    if (res.data.success === false) {
                        throw new Error(res.data.message);
                    }
                    if (res.data) {
                        commit('setLoading');
                        console.log('res', res.data)
                        return res.data
                    }
                }).catch(error => {//catch error
                    commit('setLoading');
                    commit('clearError');
                    commit('setError', error);
                });
        },
        async withdraw({ commit }, payload) {
            return await Axios
                .post(
                    process.env.VUE_APP_API_URL_PAYMENT,
                    payload,
                    {
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': 'Bearer ' + localStorage.getItem('token')
                        }
                    }
                )
                .then((res) => {
                    console.log(res.data)
                    return res.data
                });
        },
        async confirmWithdraw({ commit }, payload) {
            return await Axios.put(
                `${process.env.VUE_APP_API_URL_PAYMENT}/${payload}`,
                {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: "Bearer " + localStorage.getItem("token"),
                    },
                }
            ).then((res) => {
                console.log(res.data)
                return res.data
            });
        }
    },
    mutations: {
        setOrders(state, payload) {
            state.orders = payload
        },
        setBalance(state, payload) {
            state.balance = payload
        },
    }
}
